"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppInsights = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const AppInsights_1 = require("@/Utils/AppInsights");
const useAppInsights = () => {
    const connectionString = (0, react_redux_1.useSelector)((state) => state.initialData.appInsightsConnectionString);
    (0, react_1.useEffect)(() => {
        if (!connectionString) {
            return;
        }
        return (0, AppInsights_1.watchAppInsightsConsent)(connectionString);
    }, [connectionString]);
};
exports.useAppInsights = useAppInsights;
